/**
 * Browser-safe entry point: `@repo/payments/client`.
 *
 * Everything re-exported here must stay free of server-only imports
 * (`@repo/database`, `@repo/logs`, Stripe). Safe to use in `"use client"`
 * components and marketing pages.
 */
export * from "./credit-costs";
export {
	BASE_TRACKING_PLATFORMS,
	FREE_ENTITLEMENTS,
	PLAN_ENTITLEMENTS,
	getEntitlements,
	resolvePlanKey,
	type CitationPlanBucket,
	type PlanEntitlementCategory,
	type PlanEntitlements,
} from "./plan-entitlements";
export * from "./add-ons";
export { getPlanTier } from "./plan-tier";
